import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { ActorSummary, BackResponse, BackResponseFailure } from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.actor}actors/summary`;

export interface GetActorSummaryQueryArgs {
  actorId?: string;
  actorType?: string;
  sellerId?: string;
  ownerId?: string;
}

export const getActorSummaryRequest = (
  payload: GetActorSummaryQueryArgs,
): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, { ...payload }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getActorSummaryQuery = async (
  payload: GetActorSummaryQueryArgs,
): Promise<BackResponse<ActorSummary> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<ActorSummary>>(
      getActorSummaryRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
